export default __webpack_public_path__ + "static/media/Picture7.42ebf8c5.jpg";